// Single source of truth for selectable categories and services (palvelut).
// Used in profile editing, campaign publishing, and directory/campaign filters.
export const CATEGORY_OPTIONS = [
  "Kauneus",
  "Muoti",
  "Lifestyle & vapaa-aika",
  "Terveys & hyvinvointi",
  "Ruoka & juoma",
  "Koti & sisustus",
  "Perhe & lapset",
  "Lemmikit",
  "Matkailu",
  "Ulkoilu & luonto",
  "Tapahtumat",
  "Teknologia",
  "Media & suoratoisto",
  "Pelaaminen",
  "Autoilu",
  "Rahoitus & vakuutus",
  "Kirjallisuus & kustannus",
];

export const SERVICE_OPTIONS = [
  "UGC-videot",
  "Valokuvaus",
  "Tuotekuvaus",
  "Tuotevideot",
  "Mainosvideot",
  "Voiceoverit",
  "Videon editointi",
  "Käsikirjoittaminen",
  "Blogitekstit",
  "Tekstitys",
  "Tapahtumasisältö",
  "Pitkäaikaiset yhteistyöt",
];
